export enum LcbftClassificationEnum {
  FAIBLE = "FAIBLE",
  MOYEN = "MOYEN",
  ELEVE = "ELEVE",
  INTERDIT = "INTERDIT"
}
